import React from 'react';
import './../../css/CardRedirection.css';
import {Logo} from './../../components/common/Logo/Logo.js';
import {connect} from 'react-redux';
import {OnProvisionLimitLoad,OnProvisionLimitCancel} from './../../components/SiteCat/SiteCat'
import {getMerchantData,onServerError} from './../../constants/merchantData';

class MaxProvisionLimit extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      provisioningLimit:"",
      authCode:""
    };
  }

  componentWillMount = () => {
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode
    });
  }
  componentDidMount() {
    OnProvisionLimitLoad(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      provisioningLimit : this.props.lockedposts.provisioningLimitValue,
      cancelUrlData
    });
  }
  handleCancel = event => {
    OnProvisionLimitCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    onServerError(data);
  }


  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    return(
      <React.Fragment>
      <div className="row">
          <div className="common-header-logo col-xs-12 col-sm-4 col-md-4 col-md-offset-4 col-sm-offset-4">
          <div class="paypal-logo">
                <Logo merchantName ={this.state.merchantName}/>
            </div>
          </div>
          </div>
      <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8 col-md-offset-2 col-sm-offset-2">
            <div className="provision-limit-header">{merchantData.MaxProvisioningLimit.HEADER}</div>
            <div className="provision-limit-section">{merchantData.MaxProvisioningLimit.MESSAGE1} {this.state.provisioningLimit} {merchantData.MaxProvisioningLimit.MESSAGE2}</div>
            <div className="provision-limit-cancel"><button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.MaxProvisioningLimit.LINK}</button></div>
          </div>
        </div>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(MaxProvisionLimit);